import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Feedback from '../components/Feedback';
import { closeModal, requestStart, requestThemesStart, reset } from '../redux/feedback/actions';

@connect(function ({ app: { feedback }, router }) {
  return {
    isOpen: feedback.get('isOpen'),
    subjects: feedback.get('subjects'),
    loading: feedback.get('loading'),
    saveSuccess: feedback.get('saveSuccess'),
    router,
  };
})
export default class FeedbackContainer extends Feedback {
  static propTypes = {
    dispatch: PropTypes.func,
  };

  sendGetSubjectsRequest() {
    const { dispatch } = this.props;
    dispatch(requestThemesStart());
  }

  sendFeedback() {
    const { dispatch } = this.props;
    this.clear();
    const feedback = {
      ...this.getFeedback(),
      ...this.getResolution(),
      browser: this.getBrowserVersion(),
      screen: this.props.router.result.title,
    };
    dispatch(requestStart(feedback));
  }

  closeModal(needReset) {
    const { dispatch } = this.props;
    this.clear();
    dispatch(closeModal());
    if (needReset) {
      dispatch(reset());
    }
  }

  getBrowserVersion() {
    // TODO: move to common utils service or etc.
    // from SO: https://stackoverflow.com/questions/11219582/how-to-detect-my-browser-version-and-operating-system-using-javascript
    let nAgt = navigator.userAgent;
    let browserName = navigator.appName;
    let fullVersion = '' + parseFloat(navigator.appVersion);
    let nameOffset, verOffset, ix;

    // In Opera, the true version is after "Opera" or after "Version"
    if ((verOffset = nAgt.indexOf('Opera')) !== -1) {
      browserName = 'Opera';
      fullVersion = nAgt.substring(verOffset + 6);
      if ((verOffset = nAgt.indexOf('Version')) !== -1) fullVersion = nAgt.substring(verOffset + 8);
    }
    // In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset = nAgt.indexOf('MSIE')) !== -1) {
      browserName = 'Microsoft Internet Explorer';
      fullVersion = nAgt.substring(verOffset + 5);
    }
    // In Chrome, the true version is after "Chrome"
    else if ((verOffset = nAgt.indexOf('Chrome')) !== -1) {
      browserName = 'Chrome';
      fullVersion = nAgt.substring(verOffset + 7);
    }
    // In Safari, the true version is after "Safari" or after "Version"
    else if ((verOffset = nAgt.indexOf('Safari')) !== -1) {
      browserName = 'Safari';
      fullVersion = nAgt.substring(verOffset + 7);
      if ((verOffset = nAgt.indexOf('Version')) !== -1) fullVersion = nAgt.substring(verOffset + 8);
    }
    // In Firefox, the true version is after "Firefox"
    else if ((verOffset = nAgt.indexOf('Firefox')) !== -1) {
      browserName = 'Firefox';
      fullVersion = nAgt.substring(verOffset + 8);
    }
    // In most other browsers, "name/version" is at the end of userAgent
    else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
      browserName = nAgt.substring(nameOffset, verOffset);
      fullVersion = nAgt.substring(verOffset + 1);
      if (browserName.toLowerCase() === browserName.toUpperCase()) {
        browserName = navigator.appName;
      }
    }
    // trim the fullVersion string at semicolon/space if present
    if ((ix = fullVersion.indexOf(';')) !== -1) {
      fullVersion = fullVersion.substring(0, ix);
    }

    if ((ix = fullVersion.indexOf(' ')) !== -1) {
      fullVersion = fullVersion.substring(0, ix);
    }

    return `${browserName} ${fullVersion}`;
  }

  getResolution() {
    return {
      screenResolution: `${window.screen.availWidth}x${window.screen.availHeight}`,
      browserResolution: `${window.innerWidth}x${window.innerHeight}`,
    };
  }
}
